import { Roles } from "src/utils/Constants"
import * as administrador from "./administrador"
import * as supervisor from "./supervisor"
import * as parkey from "./parkey"
import * as defaultStrategy from "./default"

const strategies = {
  [Roles.admin]: administrador,
  [Roles.supervisor]: supervisor,
  [Roles.parkey]: parkey,
}

export const getLayoutStrategy = rol => strategies[rol] || defaultStrategy
